import React from "react";
import {inject, observer} from "mobx-react";
import {observable} from "mobx";
import {IManagementStore} from "Stores/Management/types";
import TwoFactorAuthContent from "./TwoFactorAuthContent/TwoFactorAuthContent";
import {IAuthStore} from "Stores/Auth/types";

interface IProps {
    management?: IManagementStore;
    auth?: IAuthStore;
}

@inject("auth", "management")
@observer
export default class TwoFactorAuth extends React.Component<IProps> {
    @observable isLoading: boolean = true;

    async componentDidMount() {
        const currentPersonId = this.props.auth.user.person.id;
        const person = await this.props.management.getPerson(currentPersonId);
        this.props.auth.user.person.twoFactorAuthenticationEnabled = person.twoFactorAuthenticationEnabled;
        this.isLoading = false;
    }

    render() {
        return <>{this.isLoading ? <div/> : <TwoFactorAuthContent/>}</>;
    }
}
